"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSearchUsersResponseDto = instanceOfSearchUsersResponseDto;
exports.SearchUsersResponseDtoFromJSON = SearchUsersResponseDtoFromJSON;
exports.SearchUsersResponseDtoFromJSONTyped = SearchUsersResponseDtoFromJSONTyped;
exports.SearchUsersResponseDtoToJSON = SearchUsersResponseDtoToJSON;
exports.SearchUsersResponseDtoToJSONTyped = SearchUsersResponseDtoToJSONTyped;
var UserSearchResultDto_1 = require("./UserSearchResultDto");
/**
 * Check if a given object implements the SearchUsersResponseDto interface.
 */
function instanceOfSearchUsersResponseDto(value) {
    if (!('users' in value) || value['users'] === undefined)
        return false;
    return true;
}
function SearchUsersResponseDtoFromJSON(json) {
    return SearchUsersResponseDtoFromJSONTyped(json, false);
}
function SearchUsersResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'users': (json['users'].map(UserSearchResultDto_1.UserSearchResultDtoFromJSON)),
    };
}
function SearchUsersResponseDtoToJSON(json) {
    return SearchUsersResponseDtoToJSONTyped(json, false);
}
function SearchUsersResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'users': (value['users'].map(UserSearchResultDto_1.UserSearchResultDtoToJSON)),
    };
}
